import { render, staticRenderFns } from "./FAQDialog.vue?vue&type=template&id=16a791c0&"
import script from "./FAQDialog.vue?vue&type=script&lang=js&"
export * from "./FAQDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports